(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('WidgetAcumuladoChuvaPeriodoSettingsCtrl', WidgetAcumuladoChuvaPeriodoSettingsController);

  WidgetAcumuladoChuvaPeriodoSettingsController.$inject = [
    'widget',
    '$uibModalInstance',
    'PluviometrosService'
  ];

  // eslint-disable-next-line max-lines-per-function
  function WidgetAcumuladoChuvaPeriodoSettingsController(widget, $uibModalInstance, PluviometrosService) {
    const vm = this;
    //////////////////////////////////////////
    // Controller data
    vm.result = jQuery.extend(true, {}, widget);
    vm.datepickerInicialOpen = false;
    vm.datepickerFinalOpen = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.toggleInitialDatepicker = ToggleInitialDatepicker;
    vm.toggleEndDatepicker = ToggleEndDatepicker;
    vm.ok = OK;
    vm.cancel = Cancel;
    vm.intervalDateClass = intervalDateClass;
    vm.getPluviometros = updatePluviometros;
    vm.clearPropriedade = clearPropriedade;
    vm.clearPluviometro = clearPluviometro;

    //////////////////////////////////////////
    // Function declarations

    function clearPropriedade(event) {
      event && event.stopPropagation();
      vm.result.dataModelOptions.propriedade = null;

      clearPluviometro();
    }

    function clearPluviometro(event) {
      event && event.stopPropagation();

      vm.result.dataModelOptions.pluviometro = null;
    }


    function intervalDateClass(daysInterval) {
      let cssClass = 'btn';
      if (daysInterval === vm.result.daysInterval) {
        cssClass += 'btn-primary';
      } else {
        cssClass += ' btn-white';
      }

      return cssClass;
    }

    function ToggleInitialDatepicker() {
      vm.datepickerInicialOpen = !vm.datepickerInicialOpen;
    }

    function OK() {
      setEndMonthDataFinal();
      $uibModalInstance.close(vm.result);
    }

    function Cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function ToggleEndDatepicker() {
      vm.datepickerFinalOpen = !vm.datepickerFinalOpen;
    }

    async function updatePluviometros() {
      const propriedade = vm.result.dataModelOptions.propriedade;
      if (propriedade && !propriedade.pluviometro) {
        try {
          vm.result.dataModelOptions.pluviometro = null;
          const { data: pluviometros } = await PluviometrosService.list({ propriedade: propriedade.id });

          propriedade.pluviometros = pluviometros;
        } catch (error) {
          vm.error = true;
          console.error('Erro ao buscar pluviômetros', error);
        }
      }
    }

    //////////////////////////////////////////
    // Private

    function setEndMonthDataFinal() {
      const { dataFinal } = vm.result.dataModelOptions;
      if (dataFinal) {
        vm.result.dataModelOptions.dataFinal = moment(dataFinal)
          .endOf('month')
          .toDate();
      }
    }
  }
}());
